// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1W567","item":"PaymentsMobile_item__2A3kb","label":"PaymentsMobile_label__FyXJ-","amount":"PaymentsMobile_amount__1QPws"};